import React from "react";
import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 1, delay, ease }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

// Chapter label: tricolore + chapter text
export const ChapterLabel = ({ chapter }) => (
  <div className="flex items-center gap-4 mb-6">
    <span className="tricolore">
      <span className="bg-frblue" /><span className="bg-white" /><span className="bg-frred" />
    </span>
    <span className="text-gold text-xs tracking-luxe uppercase font-medium">{chapter}</span>
  </div>
);
